//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { InstagramMentionIFramePopover } from '@components/molecules/instagram-mention-iframe/InstagramMentionIFramePopover';
import { IDraftDecoratorComponentProps } from '@components/molecules/smart-input/smartInputModel';
import { getRgbaForThemeHex } from '@utils/getRgbaForThemeHex';

interface Props extends IDraftDecoratorComponentProps {
  children: React.ReactNode;
}

export const InstagramMention = ({ children, ...props }: Props) => {
  return (
    <InstagramMentionIFramePopover
      {...props}
      username={props.decoratedText.replace('@', '')}
    >
      <InstagramMentionWrapper>{children}</InstagramMentionWrapper>
    </InstagramMentionIFramePopover>
  );
};

const InstagramMentionWrapper = styled.span(
  ({ theme }) => `
  position: relative;
  overflow: hidden;
  background-color: ${getRgbaForThemeHex(theme.colors.aliases.primary, 0.1)};
  `,
);
